// @flow
import { ACTIONS } from '../actions';

export const defaultSort = (
    state: [] = null,
    action: {} = { type: '', defaultSort: {} }
): {} => {
    switch (action.type) {
        case ACTIONS.INITIALIZE:
            if (action.defaultSort) {
                return [...action.defaultSort];
            }
            return null;
        default:
            return state;
    }
};
